module.exports = __webpack_public_path__ + "static/crafter-active-bc6a4173f625962f8b1f57953f2b00ae.png";